import * as React from 'react';

import { NewbuildingFullscreenGalleryHeaderContainer } from '../containers/NewbuildingFullscreenGalleryHeader';

export const newbuildingFullscreenMediaSettings = [
  {
    minWidth: -Infinity,
    maxWidth: 641,
    options: {},
  },
  {
    minWidth: 641,
    maxWidth: Infinity,
    options: {
      contentOptions: {
        headerContent: <NewbuildingFullscreenGalleryHeaderContainer />,
      },
    },
  },
];
